import React, { useState } from "react";
import { useTheme } from "./ThemeContext";
import { Card, Button, Modal, Spinner } from "react-bootstrap";
import { IoIosSend } from "react-icons/io";
import { FaUser } from "react-icons/fa";
import axios from "axios";

const DepartmentCard = ({ dept, onSend }) => {
  const [showModal, setShowModal] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { isDark } = useTheme();

  const handleUserClick = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      throw new Error("No auth token found in localStorage");
    }

    try {
      setShowModal(true);
      setLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API}/getEachStaff`,
        {
          headers: {
            "Content-Type":"application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        const filteredStaff = response.data.data.filter(
          (item) => item.supervisor_id === dept.supervisor_id
        );
        setStaffList(filteredStaff);
      }
    } catch (err) {
      console.error("Error fetching staff:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Card
        className={`text-center shadow-sm ${
          isDark ? "bg-dark text-light" : "bg-white text-dark"
        }`}
      >
        <Card.Header
          style={{
            backgroundColor: "#B31E8D",
            color: "white",
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <strong>{dept.department}</strong>
            <FaUser
              style={{ cursor: "pointer", fontSize: "1.2rem" }}
              onClick={handleUserClick}
            />
          </div>
        </Card.Header>

        <Card.Body>
          <div className="mb-4">
            <h6 className="m-0">{dept.supervisor_name}</h6>
          </div>
          <div>
            <h4 className="m-0 fw-bold">{dept.staff_count}</h4>
            <small className="text-secondary">Staff</small>
          </div>
        </Card.Body>

        <Card.Footer
          className={isDark ? "bg-dark text-light" : "bg-white text-dark"}
        >
          <Button
            variant="outline-light"
            size="sm"
            style={{
              color: "#B31E8D",
              borderColor: "#B31E8D",
              backgroundColor: isDark ? "#2c2c2c" : "transparent",
            }}
            onClick={() => onSend(dept.department, dept.supervisor_id)}
          >
            <IoIosSend size={20} /> &nbsp; Send PA Form
          </Button>
        </Card.Footer>
      </Card>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header
          closeButton
          className={isDark ? "bg-dark text-light" : ""}
        >
          <Modal.Title>{dept.supervisor_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={isDark ? "bg-dark text-light" : ""}>
          {loading ? (
            <div className="text-center py-3">
              <Spinner
                animation="border"
                variant={isDark ? "light" : "primary"}
              />
            </div>
          ) : staffList.length > 0 ? (
            <ul className="list-group">
              {staffList.map((staff, index) => (
                <li
                  key={staff.staff_id}
                  className={`list-group-item ${
                    isDark ? "bg-dark text-light border-secondary" : ""
                  }`}
                >
                  <strong>{index + 1}.</strong> {staff.staff_name}
                </li>
              ))}
            </ul>
          ) : (
            <div className="text-muted">No staff found.</div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DepartmentCard;
